import '@types'

import { useToastNotificationsStore } from '@/stores/toastNotifications.js'
import { useModals } from './modals.js'
import SvgHeartNew from '@/components/global/svg/SvgHeartNew.vue'
import { h, onBeforeMount, onUnmounted, ref } from 'vue'
import SvgStar2 from '@/components/global/svg/SvgStar2.vue'

// Helper composable built on top of the toast notifications store for showing toasts.
export function useToastNotifications () {
  const { showTransientToast, showPersistentToast } = useToastNotificationsStore()
  const modals = useModals()

  function showAddedToFavoritesToast (styleColorId) {
    return showTransientToast([
      'Added to ',
      { text: 'Favorites', bold: true }
    ], {
      link: {
        text: 'Add to Collection',
        clickHandler: () => {
          modals.openAddToCollectionModal(styleColorId)
        }
      },
      icon: h(SvgHeartNew, {
        width: '12px',
        height: '12px'
      })
    })
  }

  /**
   * @param {MaybeRefOrGetter<string>} message
   * @param {() => void} onClick
   */
  function showOnboardingToast(message, onClick) {
    return showPersistentToast(message, {
      onClick,
      icon: h(SvgStar2, {
        viewBox: '5 5 22 22',
        width: '24px',
        height: '24px'
      }),
      centered: true
    })
  }

  return {
    showAddedToFavoritesToast,
    showOnboardingToast,
  }
}

/** @param {ToastNotificationHideRequest} hideRequest */
export function useHideToastNotifications (hideRequest = {}) {
  const hideRequestId = ref(null)

  const { addHideRequest, removeHideRequest } = useToastNotificationsStore()

  onBeforeMount(() => {
    hideRequestId.value = addHideRequest(hideRequest)
  })
  onUnmounted(() => {
    removeHideRequest(hideRequestId.value)
  })
}

